/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AccountRole {
    ADMIN = 'ADMIN',
    ACCOUNTANT = 'ACCOUNTANT',
    USER = 'USER',
    GUEST = 'GUEST',
}
